import React from 'react';
import type { OptionProps } from 'react-select';
import { components } from 'react-select';
import useAppSelector from '../../app/redux/useAppSelector';
import type { OptionTypeBase } from '../../components/Select';
import PopOver from '../../components/deprecated/PopOver';
import { UsageAnalyticsDays } from '../../organization/PricingConfig';
import InsightsRestriction from './InsightsRestriction';
import PopOverContainer from '../../components/deprecated/PopOverContainer';

const ReactSelectOption = components.Option;

type InsightsTimeOptionProps<
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
> = OptionProps<OptionType, IsMulti> & { onUpgradeClick: () => void };

const InsightsTimeOption = <
  OptionType extends OptionTypeBase,
  IsMulti extends boolean,
>({
  onUpgradeClick,
  innerProps,
  ...props
}: InsightsTimeOptionProps<OptionType, IsMulti>) => {
  const planTier = useAppSelector(
    (state) => state.session.organization.planTier,
  );

  const { value } = props.data;

  if (
    typeof value === 'number' &&
    planTier &&
    value > UsageAnalyticsDays[planTier]
  ) {
    return (
      // @ts-expect-error
      <PopOver
        arrow={<PopOverContainer.Arrow />}
        placement="left"
        popOver={<InsightsRestriction onUpgradeClick={onUpgradeClick} />}
        trigger="hover"
        popOverPortal={document.body}
      >
        <ReactSelectOption
          {...props}
          isDisabled
          innerProps={{ ...innerProps, onClick: () => {} }}
        />
      </PopOver>
    );
  }

  return <ReactSelectOption {...props} innerProps={innerProps} />;
};

export default InsightsTimeOption;
